<div class="wrapper" #wrapper>
    @for (tool of toolsList; track tool) { @if (!tool.isSettingInstance) {
    <div
        class="tool"
        [id]="'tool-' + tool.generatedId + '-' + tool.type"
        [ngClass]="{
            'tool--active': activeTool === tool,
            'tool--floating': tool.config && tool.config.parent,
            'tool--floating-index': floatingIndex,
            'tool--remove': removeOnDrop && tool === toolBeingDragged
        }"
        [ngStyle]="{
            zIndex:
                tool.config && tool.config.data && tool.config.data.zIndex
                    ? tool.config.data.zIndex
                    : null
        }"
        cdkDrag
        [cdkDragBoundary]="wrapper"
        [cdkDragFreeDragPosition]="tool.position"
        (cdkDragMoved)="onDragMoved(tool, $event)"
        (cdkDragEnded)="onDragEnded(tool, $event)"
        (mousedown)="handleToolClick(tool)"
    >
        @if (!(tool.config && tool.config.hideHandles)) {
        <div class="handles">
            <app-handle [active]="activeTool === tool" cdkDragHandle>
                <i class="fas fa-arrows-alt"></i>
            </app-handle>
            <app-handle
                [active]="activeTool === tool"
                (click)="handleCloseTool(tool)"
            >
                <i class="fas fa-times"></i>
            </app-handle>
        </div>
        }
        <div class="instance">
            <ng-template [cdkPortalOutlet]="tool.component"></ng-template>
        </div>
    </div>
    } }
</div>
